import {
  standardLabels,
  standardLabels2,
  standardLabels3,
  standardLabels4,
  standardLabels5,
  standardLabels6,
  standardLabels7,
  standardLabels8,
  standardLabels9,
  standardLabels11,
  standardLabels13,
  standardLabels14,
  standardLabels10,
  standardLabels12,
  // note,
  // note2,
  // note3,
  // note4,
  // note5,
  // note6,
  // note7,
  // note8,
  // note9,
  // note10,
  // note11,
  // note12,
  // note13,
  // note14,
  tonalA,
  tonalAb,
  tonalB,
  tonalBb,
  tonalC,
  tonalCSharp,
  tonalD,
  tonalDb,
  tonalE,
  tonalEb,
  tonalF,
  tonalFSharp,
  tonalG,
  tonalGSharp,
  hexaA,
  hexaAb,
  hexaB,
  hexaBb,
  hexaBbb,
  hexaC,
  hexaCSharp,
  hexaD,
  hexaDb,
  hexaE,
  hexaEb,
  hexaF,
  hexaFSharp,
  hexaG,
  hexaGb,
  octoA,
  octoASharp,
  octoB,
  octoC,
  octoCSharp,
  octoD,
  octoDSharp,
  octoE,
  octoESharp,
  octoF,
  octoFSharp,
  octoG,
  octoGSharp,
} from "./keyLabelsMapper";
// import { connect } from "react-redux";
// import { setPianoLabels } from "../store/actions";

function getMidiNumber(label, standardLabels) {
  let indexBridgeStart = VALIDNOTES.findIndex((x) => x === label);

  return indexBridgeStart + 21; // Return null if the label is not found
}

function generateStandardLabels(pattern) {
  const labels = {};

  let midiNumber = 21;
  let head = 0;
  let tail = pattern.length;

  for (let i = 0; i < 3; i++) {
    const noteLabel = `${pattern[head]}0`;
    labels[midiNumber] = noteLabel;
    midiNumber++;
    head++;
    if (head === tail) {
      head = 0;
    }
  }

  for (let octave = 1; octave <= 7; octave++) {
    if (head === tail) {
      head = 0;
    }
    for (let j = 0; j < 12; j++) {
      if (head === tail) {
        head = 0;
      }
      const noteLabel = `${pattern[head]}${octave}`;
      labels[midiNumber] = noteLabel;
      midiNumber++;
      head++;
      if (midiNumber > 107) break;
    }
    if (midiNumber > 107) break;
  }

  // for "8" once
  if (midiNumber <= 108) {
    if (head === tail) {
      head = 0;
    }
    const noteLabel = `${pattern[head]}8`;
    labels[midiNumber] = noteLabel;
  }

  return labels;
}

function putLabelsOnPiano(baseNote, setPianoLabels, tones, y, setBaseNote) {
  document.querySelectorAll(".ReactPiano__NoteLabelContainer").forEach((x) => {
    x.classList.remove("hide-labels");
  });
  if (tones === 1) {
    switch (baseNote) {
      case "A":
        if (y === 0 || y===2) {
          let labelsA = generateStandardLabels(hexaA);
          setPianoLabels(labelsA);
          setBaseNote(hexaA);
        } else if( y === 1) {
          let labelsBbb = generateStandardLabels(hexaBbb);
          setPianoLabels(labelsBbb);
          setBaseNote(hexaBbb);
        }
        break;
      case "D":
        let labelsD = generateStandardLabels(hexaD);
        setPianoLabels(labelsD);
        setBaseNote(hexaD);
        break;
      case "G":
        let labelsG = generateStandardLabels(hexaG);
        setPianoLabels(labelsG);
        setBaseNote(hexaG);

        break;
      case "C":
        let labelsC = generateStandardLabels(hexaC);
        setPianoLabels(labelsC);
        setBaseNote(hexaC);

        break;
      case "F":
        let labelsF = generateStandardLabels(hexaF);
        setPianoLabels(labelsF);
        setBaseNote(hexaF);

        break;
      case "B♭":
        let labelsBb = generateStandardLabels(hexaBb);
        setPianoLabels(labelsBb);
        setBaseNote(hexaBb);

        break;
      case "E♭":
        let labelsEb = generateStandardLabels(hexaEb);
        setPianoLabels(labelsEb);
        setBaseNote(hexaEb);

        break;
      case "A♭/G♯":
          let labelsAb = generateStandardLabels(hexaAb);
          setPianoLabels(labelsAb);
          setBaseNote(hexaAb);  
        break;
      case "D♭/C♯":
        if (y === 0) {
          let labelsCSharp = generateStandardLabels(hexaCSharp);
          setPianoLabels(labelsCSharp);
          setBaseNote(hexaCSharp);
        } else if( y === 1 || y === 2) {
          let labelsDb = generateStandardLabels(hexaDb);
          setPianoLabels(labelsDb);
          setBaseNote(hexaDb);
        }
        break;
      case "E":
        let labelsE = generateStandardLabels(hexaE);
        setPianoLabels(labelsE);
        setBaseNote(hexaE);

        break;
      case "B":
        let labelsB = generateStandardLabels(hexaB);
        setPianoLabels(labelsB);
        setBaseNote(hexaB);

        break;
      case "F♯":
        if (y === 0 || y === 2) {
          let labelsFSharp = generateStandardLabels(hexaFSharp);
          setPianoLabels(labelsFSharp);
          setBaseNote(hexaFSharp);
        } else if( y === 1) {
          let labelsGb = generateStandardLabels(hexaGb);
          setPianoLabels(labelsGb);
          setBaseNote(hexaGb);
        }

        break;
      case "No Labels":
        document
          .querySelectorAll(".ReactPiano__NoteLabelContainer")
          .forEach((x) => {
            x.classList.add("hide-labels");
          });
        break;
      default:
        break; // Handle any unexpected baseNote if necessary
    }
  } else if (tones === 2) {
    switch (baseNote) {
      case "A":
        let labelsA = generateStandardLabels(tonalA);
        setPianoLabels(labelsA);
        setBaseNote(tonalA);
        break;
      case "D":
        let labelsD = generateStandardLabels(tonalD);
        setPianoLabels(labelsD);
        setBaseNote(tonalD);
        break;
      case "G":
        let labelsG = generateStandardLabels(tonalG);
        setPianoLabels(labelsG);
        setBaseNote(tonalG);

        break;
      case "C":
        let labelsC = generateStandardLabels(tonalC);
        setPianoLabels(labelsC);
        setBaseNote(tonalC);

        break;
      case "F":
        let labelsF = generateStandardLabels(tonalF);
        setPianoLabels(labelsF);
        setBaseNote(tonalF);

        break;
      case "B♭":
        let labelsBb = generateStandardLabels(tonalBb);
        setPianoLabels(labelsBb);
        setBaseNote(tonalBb);

        break;
      case "E♭":
        let labelsEb = generateStandardLabels(tonalEb);
        setPianoLabels(labelsEb);
        setBaseNote(tonalEb);

        break;
      case "A♭/G♯":
          let labelsAb = generateStandardLabels(tonalAb);
          setPianoLabels(labelsAb);
          setBaseNote(tonalAb);
        break;
      case "D♭/C♯":
          let labelsDb = generateStandardLabels(tonalDb);
          setPianoLabels(labelsDb);
          setBaseNote(tonalDb);
        break;
      case "E":
        let labelsE = generateStandardLabels(tonalE);
        setPianoLabels(labelsE);
        setBaseNote(tonalE);

        break;
      case "B":
        let labelsB = generateStandardLabels(tonalB);
        setPianoLabels(labelsB);
        setBaseNote(tonalB);

        break;
      case "F♯":
        let labelsFSharp = generateStandardLabels(tonalFSharp);
        setPianoLabels(labelsFSharp);
        setBaseNote(tonalFSharp);

        break;
      case "No Labels":
        document
          .querySelectorAll(".ReactPiano__NoteLabelContainer")
          .forEach((x) => {
            x.classList.add("hide-labels");
          });
        break;
      default:
        break; // Handle any unexpected baseNote if necessary
    }
  } else if (tones === 3) {
    switch (baseNote) {
      case "A":
        let labelsA = generateStandardLabels(octoA);
        setPianoLabels(labelsA);
        setBaseNote(octoA);
        break;
      case "D":
        let labelsD = generateStandardLabels(octoD);
        setPianoLabels(labelsD);
        setBaseNote(octoD);
        break;
      case "G":
        let labelsG = generateStandardLabels(octoG);
        setPianoLabels(labelsG);
        setBaseNote(octoG);

        break;
      case "C":
        let labelsC = generateStandardLabels(octoC);
        setPianoLabels(labelsC);
        setBaseNote(octoC);

        break;
      case "F":
        if (y === 0) {
          let labelsESharp = generateStandardLabels(octoESharp);
          setPianoLabels(labelsESharp);
          setBaseNote(octoESharp);
        } else if( y === 1) {
          let labelsF = generateStandardLabels(octoF);
          setPianoLabels(labelsF);
          setBaseNote(octoF);
        }

        break;
      case "B♭":
        let labelsASharp = generateStandardLabels(octoASharp);
        setPianoLabels(labelsASharp);
        setBaseNote(octoASharp);

        break;
      case "E♭":
          let labelsEb = generateStandardLabels(octoDSharp);
          setPianoLabels(labelsEb);
          setBaseNote(octoDSharp);       

        break;
      case "A♭/G♯":
        let labelGSharp = generateStandardLabels(octoGSharp);
        setPianoLabels(labelGSharp);
        setBaseNote(octoGSharp);
        break;
      case "D♭/C♯":
        let labelsCSharp = generateStandardLabels(octoCSharp);
        setPianoLabels(labelsCSharp);
        setBaseNote(octoCSharp);
        break;
      case "E":
        let labelsE = generateStandardLabels(octoE);
        setPianoLabels(labelsE);
        setBaseNote(octoE);

        break;
      case "B":
        let labelsB = generateStandardLabels(octoB);
        setPianoLabels(labelsB);
        setBaseNote(octoB);

        break;
      case "F♯":
        let labelsFSharp = generateStandardLabels(octoFSharp);
        setPianoLabels(labelsFSharp);
        setBaseNote(octoFSharp);

        break;
      case "No Labels":
        document
          .querySelectorAll(".ReactPiano__NoteLabelContainer")
          .forEach((x) => {
            x.classList.add("hide-labels");
          });
        break;
      default:
        break; // Handle any unexpected baseNote if necessary
    }
  }
}

function changeLabels(selectedLabel, setPianoLabels, tonesMT, setBaseNote) {
  document.querySelectorAll(".ReactPiano__NoteLabelContainer").forEach((x) => {
    x.classList.remove("hide-labels");
  });
  // Based on selected label, apply the appropriate label set
  switch (selectedLabel.trim()) {
    case "{ A } { A, A♯, B, C, C♯, D, D♯, E, F, F♯, G, G♯ }":
      setPianoLabels(standardLabels);
      setBaseNote(tonalA);
      break;
    case "{ B } { A, A♯, B, B♯, C♯, D, D♯, E, E♯, F♯, G, G♯ }":
      setPianoLabels(standardLabels9);
      setBaseNote(tonalB);
      break;
    case "{ C } { A, B♭, B, C, C♯, D, E♭, E, F, F♯, G, A♭ }":
      setPianoLabels(standardLabels6);
      setBaseNote(tonalC);
      break;
    case "{ D } { A, B♭, B, C, C♯, D, D♯, E, F, F♯, G, G♯ }":
      setPianoLabels(standardLabels7);
      setBaseNote(tonalD);
      break;
    case "{ E } { A, A♯, B, C, C♯, D, D♯, E, E♯, F♯, G, G♯ }":
      setPianoLabels(standardLabels8);
      setBaseNote(tonalE);
      break;
    case "{ F } { A, B♭, B, C, D♭, D, E♭, E, F, F♯, G, A♭ }":
      setPianoLabels(standardLabels14);
      setBaseNote(tonalF);
      break;
    case "{ G } { A, B♭, B, C, C♯, D, E♭, E, F, F♯, G, G♯ }":
      setPianoLabels(standardLabels3);
      setBaseNote(tonalG);
      break;
    case "{ A♭/G♯ } { A, B♭, C♭, C, D♭, D, E♭, F♭, F, G♭, G, A♭ }":
      setPianoLabels(standardLabels11);
      setBaseNote(tonalAb);
      break;
    case "{ B♭ } { A, B♭, B, C, D♭, D, E♭, E, F, G♭, G, A♭ }":
      setPianoLabels(standardLabels2);
      setBaseNote(tonalBb);
      break;
    case "{ D♭/C♯ } { B𝄫, B♭, C♭, C, D♭, D, E♭, F♭, F, G♭, G, A♭ }":
      setPianoLabels(standardLabels4);
      setBaseNote(tonalDb);
      break;
    case "{ E♭ } { A, B♭, C♭, C, D♭, D, E♭, E, F, G♭, G, A♭ }":
      setPianoLabels(standardLabels13);
      setBaseNote(tonalEb);
      break;
    case "{ F♯ } { A, A♯, B, B♯, C♯, D, D♯, E, E♯, F♯, G, G♯ }":
      setPianoLabels(standardLabels5);
      setBaseNote(tonalFSharp);
      break;
    case "No Labels":
      // Hide labels if "No Labels" is selected
      document
        .querySelectorAll(".ReactPiano__NoteLabelContainer")
        .forEach((x) => {
          x.classList.add("hide-labels");
        });
      break;
    default:
  }
}

const VALIDNOTES = [
  "A0",
  "B♭0", // Replaced A♯ with B♭
  "B0",
  "C1",
  "C♯1",
  "D1",
  "E♭1", // Replaced D♯ with E♭
  "E1",
  "F1",
  "F♯1",
  "G1",
  "G♯1",
  "A1",
  "B♭1", // Replaced A♯ with B♭
  "B1",
  "C2",
  "C♯2",
  "D2",
  "E♭2", // Replaced D♯ with E♭
  "E2",
  "F2",
  "F♯2",
  "G2",
  "G♯2",
  "A2",
  "B♭2", // Replaced A♯ with B♭
  "B2",
  "C3",
  "C♯3",
  "D3",
  "E♭3", // Replaced D♯ with E♭
  "E3",
  "F3",
  "F♯3",
  "G3",
  "G♯3",
  "A3",
  "B♭3", // Replaced A♯ with B♭
  "B3",
  "C4",
  "C♯4",
  "D4",
  "E♭4", // Replaced D♯ with E♭
  "E4",
  "F4",
  "F♯4",
  "G4",
  "G♯4",
  "A4",
  "B♭4", // Replaced A♯ with B♭
  "B4",
  "C5",
  "C♯5",
  "D5",
  "E♭5", // Replaced D♯ with E♭
  "E5",
  "F5",
  "F♯5",
  "G5",
  "G♯5",
  "A5",
  "B♭5", // Replaced A♯ with B♭
  "B5",
  "C6",
  "C♯6",
  "D6",
  "E♭6", // Replaced D♯ with E♭
  "E6",
  "F6",
  "F♯6",
  "G6",
  "G♯6",
  "A6",
  "B♭6", // Replaced A♯ with B♭
  "B6",
  "C7",
  "C♯7",
  "D7",
  "E♭7", // Replaced D♯ with E♭
  "E7",
  "F7",
  "F♯7",
  "G7",
  "G♯7",
  "A7",
  "B♭7", // Replaced A♯ with B♭
  "B7",
  "C8",
];
const NOTES = [
  "A",
  "B♭",
  "B",
  "C",
  "D♭/C♯",
  "D",
  "E♭",
  "E",
  "F",
  "F♯",
  "G",
  "A♭/G♯",
];
// const NOTES = [
//   { key: "A", mapper: "ALLNOTES3" },
//   { key: "B♭", mapper: "ALLNOTES2" },
//   { key: "B", mapper: "ALLNOTES" },
//   { key: "C", mapper: "ALLNOTES2" },
//   { key: "D♭", mapper: "ALLNOTES4" },
//   { key: "D", mapper: "ALLNOTES3" },
//   { key: "E♭", mapper: "ALLNOTES4" },
//   { key: "E", mapper: "ALLNOTES" },
//   { key: "F", mapper: "ALLNOTES2" },
//   { key: "F♯", mapper: "ALLNOTES5" },
//   { key: "G", mapper: "ALLNOTES3" },
//   { key: "A♭", mapper: "ALLNOTES4" },
// ];
// A
const ALLNOTES = [
  "A0",
  "A♯0",
  "B0",
  "C1",
  "C♯1",
  "D1",
  "D♯1",
  "E1",
  "F1",
  "F♯1",
  "G1",
  "G♯1",
  "A1",
  "A♯1",
  "B1",
  "C2",
  "C♯2",
  "D2",
  "D♯2",
  "E2",
  "F2",
  "F♯2",
  "G2",
  "G♯2",
  "A2",
  "A♯2",
  "B2",
  "C3",
  "C♯3",
  "D3",
  "D♯3",
  "E3",
  "F3",
  "F♯3",
  "G3",
  "G♯3",
  "A3",
  "A♯3",
  "B3",
  "C4",
  "C♯4",
  "D4",
  "D♯4",
  "E4",
  "F4",
  "F♯4",
  "G4",
  "G♯4",
  "A4",
  "A♯4",
  "B4",
  "C5",
  "C♯5",
  "D5",
  "D♯5",
  "E5",
  "F5",
  "F♯5",
  "G5",
  "G♯5",
  "A5",
  "A♯5",
  "B5",
  "C6",
  "C♯6",
  "D6",
  "D♯6",
  "E6",
  "F6",
  "F♯6",
  "G6",
  "G♯6",
  "A6",
  "A♯6",
  "B6",
  "C7",
  "C♯7",
  "D7",
  "D♯7",
  "E7",
  "F7",
  "F♯7",
  "G7",
  "G♯7",
  "A7",
  "A♯7",
  "B7",
  "C8",
  "C♯8",
  "D8",
  "D♯8",
  "E8",
  "F8",
  "F♯8",
  "G8",
  "G♯8",
];
// const NOTES2 = ["A", "B♭", "B", "C", "D♭", "D", "E♭", "E", "F", "G♭", "G",A♭];
// const NOTES3 = [
//   "A",
//   "B♭",
//   "B",
//   "C",
//   "C♯",
//   "D",
//   "E♭",
//   "E",
//   "F",
//   "F♯",
//   "G2",
//   "G♯",
// ];
// const NOTES4 = [
//   "B♭♭",
//   "B♭",
//   "C♭",
//   "C",
//   "D♭",
//   "D",
//   "E♭",
//   "F♭",
//   "F",
//   "G♭",
//   "G",
//   "A♭",
// ];
// const NOTES5 = [
//   "A",
//   "A♯",
//   "B",
//   "B♯",
//   "C♯",
//   "D",
//   "D♯",
//   "E",
//   "EX",
//   "F♯",
//   "FX",
//   "G♯",
// ];
// const NOTES5 = ["A", "A♯", "B", "C", "C♯", "D", "D♯", "E", "F", "F♯", "G", "G♯"];
const ALLNOTES2 = [
  "A0",
  "B♭0",
  "B0",
  "C1",
  "D♭1",
  "D1",
  "E♭1",
  "E1",
  "F1",
  "G♭1",
  "G1",
  "A1",
  "B♭1",
  "B1",
  "B1",
  "C2",
  "D♭2",
  "D2",
  "E♭2",
  "E2",
  "F2",
  "G♭2",
  "G2",
  "A2",
  "B♭2",
  "B2",
  "B2",
  "C3",
  "D♭3",
  "D3",
  "E♭3",
  "E3",
  "F3",
  "G♭3",
  "G3",
  "A3",
  "B♭3",
  "B3",
  "B3",
  "C4",
  "D♭4",
  "D4",
  "E♭4",
  "E4",
  "F4",
  "G♭4",
  "G4",
  "A4",
  "B♭4",
  "B4",
  "B4",
  "C5",
  "D♭5",
  "D5",
  "E♭5",
  "E5",
  "F5",
  "G♭5",
  "G5",
  "A5",
  "B♭5",
  "B5",
  "B5",
  "C6",
  "D♭6",
  "D6",
  "E♭6",
  "E6",
  "F6",
  "G♭6",
  "G6",
  "A6",
  "B♭6",
  "B6",
  "B6",
  "C7",
  "D♭7",
  "D7",
  "E♭7",
  "E7",
  "F7",
  "G♭7",
  "G7",
  "A7",
  "B♭7",
  "B7",
  "B7",
  "C8",
  "D♭8",
  "D8",
  "E♭8",
  "E8",
  "F8",
  "G♭8",
  "G8",
];
const ALLNOTES3 = [
  "A0",
  "B♭0",
  "B0",
  "C1",
  "C♯1",
  "D1",
  "E♭1",
  "E1",
  "F1",
  "F♯1",
  "G1",
  "G♯1",
  "A1",
  "B♭1",
  "B1",
  "C2",
  "C♯2",
  "D2",
  "E♭2",
  "E2",
  "F2",
  "F♯2",
  "G2",
  "G♯2",
  "A2",
  "B♭2",
  "B2",
  "C3",
  "C♯3",
  "D3",
  "E♭3",
  "E3",
  "F3",
  "F♯3",
  "G3",
  "G♯3",
  "A3",
  "B♭3",
  "B3",
  "C4",
  "C♯4",
  "D4",
  "E♭4",
  "E4",
  "F4",
  "F♯4",
  "G4",
  "G♯4",
  "A4",
  "B♭4",
  "B4",
  "C5",
  "C♯5",
  "D5",
  "E♭5",
  "E5",
  "F5",
  "F♯5",
  "G5",
  "G♯5",
  "A5",
  "B♭5",
  "B5",
  "C6",
  "C♯6",
  "D6",
  "E♭6",
  "E6",
  "F6",
  "F♯6",
  "G6",
  "G♯6",
  "A6",
  "B♭6",
  "B6",
  "C7",
  "C♯7",
  "D7",
  "E♭7",
  "E7",
  "F7",
  "F♯7",
  "G7",
  "G♯7",
  "A7",
  "B♭7",
  "B7",
  "C8",
  "C♯8",
  "D8",
  "E♭8",
  "E8",
  "F8",
  "F♯8",
  "G8",
  "G♯8",
];
const ALLNOTES4 = [
  "A♭0",
  "B♭♭0",
  "B♭0",
  "C♭1",
  "C1",
  "D♭1",
  "D1",
  "E♭1",
  "F♭1",
  "F1",
  "G♭1",
  "G1",
  "A♭1",
  "B♭♭1",
  "B♭1",
  "C♭2",
  "C2",
  "D♭2",
  "D2",
  "E♭2",
  "F♭2",
  "F2",
  "G♭2",
  "G2",
  "A♭2",
  "B♭♭2",
  "B♭2",
  "C♭3",
  "C3",
  "D♭3",
  "D3",
  "E♭3",
  "F♭3",
  "F3",
  "G♭3",
  "G3",
  "A♭3",
  "B♭♭3",
  "B♭3",
  "C♭4",
  "C4",
  "D♭4",
  "D4",
  "E♭4",
  "F♭4",
  "F4",
  "G♭4",
  "G4",
  "A♭4",
  "B♭♭4",
  "B♭4",
  "C♭5",
  "C5",
  "D♭5",
  "D5",
  "E♭5",
  "F♭5",
  "F5",
  "G♭5",
  "G5",
  "A♭5",
  "B♭♭5",
  "B♭5",
  "C♭6",
  "C6",
  "D♭6",
  "D6",
  "E♭6",
  "F♭6",
  "F6",
  "G♭6",
  "G6",
  "A♭6",
  "B♭♭6",
  "B♭6",
  "C♭7",
  "C7",
  "D♭7",
  "D7",
  "E♭7",
  "F♭7",
  "F7",
  "G♭7",
  "G7",
  "A♭7",
  "B♭♭7",
  "B♭7",
  "C♭8",
  "C8",
  "D♭8",
  "D8",
  "E♭8",
  "F♭8",
  "F8",
  "G♭8",
  "G8",
];
const ALLNOTES5 = [
  "A0",
  "A♯0",
  "B0",
  "B♯0",
  "C♯1",
  "D1",
  "D♯1",
  "E1",
  "EX1",
  "F♯1",
  "FX1",
  "G♯1",
  "A1",
  "A♯1",
  "B1",
  "B♯1",
  "C♯2",
  "D2",
  "D♯2",
  "E2",
  "EX2",
  "F♯2",
  "FX2",
  "G♯2",
  "A2",
  "A♯2",
  "B2",
  "B♯2",
  "C♯3",
  "D3",
  "D♯3",
  "E3",
  "EX3",
  "F♯3",
  "FX3",
  "G♯3",
  "A3",
  "A♯3",
  "B3",
  "B♯3",
  "C♯4",
  "D4",
  "D♯4",
  "E4",
  "EX4",
  "F♯4",
  "FX4",
  "G♯4",
  "A4",
  "A♯4",
  "B4",
  "B♯4",
  "C♯5",
  "D5",
  "D♯5",
  "E5",
  "EX5",
  "F♯5",
  "FX5",
  "G♯5",
  "A5",
  "A♯5",
  "B5",
  "B♯5",
  "C♯6",
  "D6",
  "D♯6",
  "E6",
  "EX6",
  "F♯6",
  "FX6",
  "G♯6",
  "A6",
  "A♯6",
  "B6",
  "B♯6",
  "C♯7",
  "D7",
  "D♯7",
  "E7",
  "EX7",
  "F♯7",
  "FX7",
  "G♯7",
  "A7",
  "A♯7",
  "B7",
  "B♯7",
  "C♯8",
  "D8",
  "D♯8",
  "E8",
  "EX8",
  "F♯8",
  "FX8",
  "G♯8",
];

const TONES = [
  "Pentatonic Scales",
  "Hexaphonic Scales",
  "Tonal Scales and Modes",
  "Octophonic Scales",
  "Other Scales",
];
const sevenToneScale = [
  {
    x: 0,
    y: 0,
    prevDegree: "1.",
    name: "ionian",
    nameColor: "#FF0000",
    formulae: [1, 3, 5, 6, 8, 10, 12],
    formulaeOriginal: ["1", "3", "5", "6", "8", "0", "B"],
    numbers: ["1", "2", "3", "4", "5", "6", "7"],
    underlinedNumbers: ["4", "7"],
    // doubleUnderlineNumbers: ["2", "3"],
  },
  {
    x: 1,
    y: 0,
    prevDegree: "2.",
    name: "dorian",
    nameColor: "#FFFF00",
    formulae: [1, 3, 4, 6, 8, 10, 11],
    formulaeOriginal: ["1", "3", "4", "6", "8", "0", "A"],
    numbers: ["1", "2", "b3", "4", "5", "6", "b7"],
    underlinedNumbers: ["b3", "6"],
    // doubleUnderlineNumbers: ["5", "b7"],
  },
  {
    x: 2,
    y: 0,
    prevDegree: "3.",
    name: "phrygian",
    nameColor: "#1e62ff",
    formulae: [1, 2, 4, 6, 8, 9, 11],
    formulaeOriginal: ["1", "2", "4", "6", "8", "9", "A"],
    numbers: ["1", "b2", "b3", "4", "5", "b6", "b7"],
    underlinedNumbers: ["b2", "5"],
  },
  {
    x: 3,
    y: 0,
    prevDegree: "4.",
    name: "lydian",
    nameColor: "#ff00b7",
    formulae: [1, 3, 5, 7, 8, 10, 12],
    formulaeOriginal: ["1", "3", "5", "7", "8", "0", "B"],
    numbers: ["1", "2", "3", "♯4", "5", "6", "7"],
    underlinedNumbers: ["1", "♯4"],
  },
  {
    x: 4,
    y: 0,
    prevDegree: "5.",
    name: "mixo",
    nameColor: "#FF7F00",
    formulae: [1, 3, 5, 6, 8, 10, 11],
    formulaeOriginal: ["1", "3", "5", "6", "8", "0", "A"],
    numbers: ["1", "2", "3", "4", "5", "6", "b7"],
    underlinedNumbers: ["3", "b7"],
  },
  {
    x: 5,
    y: 0,
    prevDegree: "6.",
    name: "aeolian",
    nameColor: "#00FF00",
    formulae: [1, 3, 4, 6, 8, 9, 11],
    formulaeOriginal: ["1", "3", "4", "6", "8", "9", "A"],
    numbers: ["1", "2", "b3", "4", "5", "b6", "b7"],
    underlinedNumbers: ["2", "b6"],
  },
  {
    x: 6,
    y: 0,
    prevDegree: "7.",
    name: "locrian",
    nameColor: "#AE96FF",
    formulae: [1, 2, 4, 6, 7, 9, 11],
    formulaeOriginal: ["1", "2", "4", "6", "7", "9", "A"],
    numbers: ["1", "b2", "b3", "4", "b5", "b6", "b7"],
    underlinedNumbers: ["1", "b5"],
  },
  {
    x: 0,
    y: 3,
    prevDegree: "1.",
    name: "ionian",
    nameColor: "#FF0000",
    degree: "b3",
    degreeColor: "#FFFF00",
    formulae: [1, 3, 4, 6, 8, 10, 12],
    formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
    numbers: ["1", "2", "b3", "4", "5", "6", "7"],
    doubleUnderlineNumbers: ["b3", "6"],
    underlinedNumbers: ["4", "7"],
  },
  {
    x: 1,
    y: 3,
    prevDegree: "2.",
    name: "dorian",
    nameColor: "#FFFF00",
    degree: "b2",
    degreeColor: "#1e62ff",
    formulae: [1, 2, 4, 6, 8, 10, 11],
    formulaeOriginal: ["1", "3", "4", "6", "8", "0", "B"],
    numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
    doubleUnderlineNumbers: ["2", "b5"],
    underlinedNumbers: ["b3", "6"],
  },
  {
    x: 2,
    y: 3,
    prevDegree: "b3.",
    name: "lydian",
    nameColor: "#ff00b7",
    degree: "♯5",
    degreeColor: "#00FF00",
    // secondDegree: "♯5",
    // secondDegreeColor: "#fff",
    formulae: [1, 3, 5, 7, 9, 10, 12],
    formulaeOriginal: ["1", "3", "5", "7", "9", "0", "B"],
    numbers: ["1", "2", "3", "♯4", "♯5", "6", "7"],
    doubleUnderlineNumbers: ["1", "♯4"],
    underlinedNumbers: ["2", "♯5"],
  },
  {
    x: 3,
    y: 3,
    prevDegree: "4.",
    name: "lydian",
    nameColor: "#ff00b7",
    degree: "b7",
    degreeColor: "#FF7F00",
    formulae: [1, 3, 5, 7, 8, 10, 11],
    formulaeOriginal: ["1", "3", "5", "7", "8", "0", "A"],
    numbers: ["1", "2", "3", "♯4", "5", "6", "b7"],
    underlinedNumbers: ["1", "♯4"],
    doubleUnderlineNumbers: ["3", "b7"],
  },
  {
    x: 4,
    y: 3,
    prevDegree: "5.",
    name: "mixo",
    nameColor: "#FF7F00",
    degree: "b6",
    degreeColor: "#00FF00",
    formulae: [1, 3, 5, 6, 8, 9, 11],
    formulaeOriginal: ["1", "3", "5", "6", "8", "9", "A"],
    numbers: ["1", "2", "3", "4", "5", "b6", "b7"],
    underlinedNumbers: ["b7", "3"],
    doubleUnderlineNumbers: ["2", "b6"],
  },
  {
    x: 5,
    y: 3,
    prevDegree: "6.",
    name: "aeolian",
    nameColor: "#AE96FF",
    degree: "b5",
    degreeColor: "#00FF00",
    formulae: [1, 3, 4, 6, 7, 9, 11],
    formulaeOriginal: ["1", "3", "4", "6", "7", "9", "A"],
    numbers: ["1", "2", "b3", "4", "b5", "b6", "b7"],
    doubleUnderlineNumbers: ["1", "b5"],
    underlinedNumbers: ["2", "b6"],
  },
  {
    x: 6,
    y: 3,
    prevDegree: "7.",
    name: "locrian",
    nameColor: "#AE96FF",
    degree: "b4",
    degreeColor: "#FF7F00",
    text: "(Altered Dominant)",
    formulae: [1, 2, 4, 5, 7, 9, 11],
    formulaeOriginal: ["1", "2", "4", "5", "7", "9", "A"],
    numbers: ["1", "b2", "b3", "b4", "b5", "b6", "b7"],
    underlinedNumbers: ["1", "b5"],
    doubleUnderlineNumbers: ["b4", "b7"],
  },
  {
    x: 0,
    y: 2,
    prevDegree: "1.",
    name: "aeolian",
    nameColor: "#00FF00",
    degree: "♮7",
    degreeColor: "#FF0000",
    formulae: [1, 3, 4, 6, 8, 9, 12],
    formulaeOriginal: ["1", "3", "4", "6", "8", "9", "B"],
    numbers: ["1", "2", "b3", "4", "5", "b6", "7"],
    underlinedNumbers: ["4", "7"],
    doubleUnderlineNumbers: ["2", "b6"],
  },
  {
    x: 1,
    y: 2,
    prevDegree: "2.",
    name: "locrian",
    nameColor: "#AE96FF",
    degree: "♮6",
    degreeColor: "#FFFF00",
    formulae: [1, 2, 4, 6, 7, 10, 11],
    formulaeOriginal: ["1", "2", "4", "6", "7", "0", "A"],
    numbers: ["1", "b2", "b3", "4", "b5", "6", "b7"],
    doubleUnderlineNumbers: ["1", "b5"],
    underlinedNumbers: ["b3", "6"],
  },
  {
    x: 2,
    y: 2,
    prevDegree: "b3.",
    name: "ionian",
    nameColor: "#FF0000",
    degree: "♯5",
    degreeColor: "#00FF00",
    formulae: [1, 3, 5, 6, 9, 10, 12],
    formulaeOriginal: ["1", "3", "5", "6", "9", "0", "B"],
    numbers: ["1", "2", "3", "4", "♯5", "6", "7"],
    doubleUnderlineNumbers: ["4", "7"],
    underlinedNumbers: ["2", "♯5"],
  },
  {
    x: 3,
    y: 2,
    prevDegree: "4.",
    name: "dorian",
    nameColor: "#FFFF00",
    degree: "♯4",
    degreeColor: "#ff00b7",
    formulae: [1, 3, 4, 7, 8, 10, 11],
    formulaeOriginal: ["1", "3", "4", "7", "8", "0", "A"],
    numbers: ["1", "2", "b3", "♯4", "5", "6", "b7"],
    underlinedNumbers: ["1", "♯4"],
    doubleUnderlineNumbers: ["b3", "6"],
  },
  {
    x: 4,
    y: 2,
    prevDegree: "5.",
    name: "phrygian",
    nameColor: "#1e62ff",
    degree: "♮3",
    degreeColor: "#ff7f00",
    formulae: [1, 2, 5, 6, 8, 9, 11],
    formulaeOriginal: ["1", "2", "5", "6", "8", "9", "A"],
    numbers: ["1", "b2", "3", "4", "5", "b6", "b7"],
    underlinedNumbers: ["3", "b7"],
    doubleUnderlineNumbers: ["b2", "5"],
  },
  {
    x: 5,
    y: 2,
    prevDegree: "b6.",
    name: "lydian",
    nameColor: "#ff00b7",
    degree: "♯2",
    degreeColor: "#FFFF00",
    formulae: [1, 4, 5, 7, 8, 10, 12],
    formulaeOriginal: ["1", "4", "5", "7", "8", "0", "B"],
    numbers: ["1", "♯2", "3", "♯4", "5", "6", "7"],
    doubleUnderlineNumbers: ["1", "♯4"],
    underlinedNumbers: ["♯2", "6"],
  },

  {
    x: 6,
    y: 2,
    prevDegree: "7.",
    name: "locrian",
    nameColor: "#ae96ff",
    degree: "b4",
    degreeColor: "#ff00b7",
    secondDegree: "bb7",
    secondDegreeColor: "#FFFF00",
    text: "(Altered bb7)",
    formulae: [1, 2, 4, 5, 7, 9, 10],
    formulaeOriginal: ["1", "2", "4", "5", "7", "9", "0"],
    numbers: ["1", "b2", "b3", "b4", "b5", "b6", "bb7"],
    underlinedNumbers: ["1", "b5"],
    doubleUnderlineNumbers: ["b3", "bb7"],
  },
  {
    x: 0,
    y: 1,
    prevDegree: "1.",
    name: "ionian",
    nameColor: "#FF0000",
    degree: "b6",
    degreeColor: "#00FF00",
    formulae: [1, 3, 5, 6, 8, 9, 12],
    formulaeOriginal: ["1", "3", "5", "6", "8", "9", "B"],
    numbers: ["1", "2", "3", "4", "5", "b6", "7"],
    doubleUnderlineNumbers: ["2", "b6"],
    underlinedNumbers: ["4", "7"],
  },
  {
    x: 1,
    y: 1,
    prevDegree: "2.",
    name: "dorian",
    nameColor: "#FFFF00",
    degree: "b5",
    degreeColor: "#ae96ff",
    formulae: [1, 3, 4, 6, 7, 10, 11],
    formulaeOriginal: ["1", "3", "4", "6", "7", "0", "A"],
    numbers: ["1", "2", "b3", "4", "b5", "6", "b7"],
    doubleUnderlineNumbers: ["1", "b5"],
    underlinedNumbers: ["b3", "6"],
  },
  {
    x: 2,
    y: 1,
    prevDegree: "3.",
    name: "phrygian",
    nameColor: "#1e62ff",
    degree: "b4",
    degreeColor: "#FF7F00",
    formulae: [1, 2, 4, 5, 8, 9, 11],
    formulaeOriginal: ["1", "2", "4", "5", "8", "9", "A"],
    numbers: ["1", "b2", "b3", "b4", "5", "b6", "b7"],
    underlinedNumbers: ["b2", "5"],
    doubleUnderlineNumbers: ["b4", "b7"],
  },
  {
    x: 3,
    y: 1,
    prevDegree: "4.",
    name: "lydian",
    nameColor: "#ff00b7",
    degree: "b3",
    degreeColor: "#FFFF00",
    formulae: [1, 3, 4, 7, 8, 10, 12],
    formulaeOriginal: ["1", "3", "4", "7", "8", "0", "B"],
    numbers: ["1", "2", "b3", "♯4", "5", "6", "7"],
    underlinedNumbers: ["1", "♯4"],
    doubleUnderlineNumbers: ["b3", "6"],
  },
  {
    x: 4,
    y: 1,
    prevDegree: "5.",
    name: "mixo",
    nameColor: "#FF7F00",
    degree: "b2",
    degreeColor: "#1e62ff",
    formulae: [1, 2, 5, 6, 8, 10, 11],
    formulaeOriginal: ["1", "2", "5", "6", "8", "0", "A"],
    numbers: ["1", "b2", "3", "4", "5", "6", "b7"],
    doubleUnderlineNumbers: ["b2", "5"],
    underlinedNumbers: ["3", "b7"],
  },
  {
    x: 5,
    y: 1,
    prevDegree: "b6.",
    name: "lydian",
    nameColor: "#ff00b7",
    degree: "♯2",
    degreeColor: "#FFFF00",
    secondDegree: "♯5",
    secondDegreeColor: "#fff",
    formulae: [1, 4, 5, 7, 9, 10, 12],
    formulaeOriginal: ["1", "4", "5", "7", "9", "0", "B"],
    numbers: ["1", "♯2", "3", "♯4", "♯5", "6", "7"],
    doubleUnderlineNumbers: ["1", "♯4"],
    underlinedNumbers: ["♯2", "6"],
  },
  {
    x: 6,
    y: 1,
    prevDegree: "7.",
    name: "locrian",
    nameColor: "#AE96FF",
    degree: "bb7",
    degreeColor: "#FFFF00",
    formulae: [1, 2, 4, 6, 7, 9, 10],
    formulaeOriginal: ["1", "2", "4", "6", "7", "9", "0"],
    numbers: ["1", "b2", "b3", "4", "b5", "b6", "bb7"],
    doubleUnderlineNumbers: ["b3", "bb7"],
    underlinedNumbers: ["1", "b5"],
  },
];
const fiveToneScale = [
  {
    x: 0,
    y: 0,
    name: "Major",
    nameColor: "#fff",
    degreeColor: "#fff",
    formulae: [1, 3, 5, 8, 10],
    formulaeOriginal: ["1", "3", "5", "8", "0"],
    numbers: ["1", "2", "3", "5", "6"],
  },

  {
    x: 0,
    y: 1,
    name: "Minor",
    nameColor: "#fff",
    degreeColor: "#fff",
    formulae: [1, 4, 6, 8, 11],
    formulaeOriginal: ["1", "4", "6", "8", "A"],
    numbers: ["1", "b3", "4", "5", "b7"],
  },
];
const eightToneScale = [
  {
    x: 0,
    y: 0,
    name: "Half/whole",
    formulae: [1, 2, 4, 5, 7, 8, 10, 11],
    formulaeOriginal: ["1", "2", "4", "5", "7", "8", "0", "A"],
    numbers: ["1", "b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
    underlinedNumbers: ["b2", "b3", "b4", "b5", "bb6", "bb7", "bb8"],
    squareNumbers: ["b2", "b4", "bb6", "bb8"],
  },
  {
    x: 1,
    y: 0,
    name: "Whole/half",
    formulae: [1, 3, 4, 6, 7, 9, 10, 12],
    formulaeOriginal: ["1", "3", "4", "6", "7", "9", "0", "B"],
    numbers: ["1", "2", "b3", "4", "b5", "bb6", "bb7", "bb8"],
    underlinedNumbers: ["2", "b3", "b5", "b6", "bb7", "b8"],
    squareNumbers: ["2", "4", "bb6", "bb8"],
  },
];
const sixToneScale = [
  {
    x: 0,
    y: 0,
    nameColor: "#fff",
    degreeColor: "#fff",
    name: "Hexa",
    degree: "b2",
    formulae: [1, 2, 5, 6, 9, 10],
    formulaeOriginal: ["1", "2", "5", "6", "9", "0"],
    numbers: ["1", "b2", "3", "4", "♯5", "6"],
    squareNumbers: ["b2", "4", "6"],
  },
  {
    x: 0,
    y: 1,
    nameColor: "#fff",
    degreeColor: "#fff",
    name: "Hexa",
    degree: "♯2",
    formulae: [1, 4, 5, 8, 9, 12],
    formulaeOriginal: ["1", "4", "5", "8", "9", "B"],
    numbers: ["1", "♯2", "3", "X4", "♯5", "X6"],
    squareNumbers: ["♯2", "X4", "X6"],
  },

  {
    x: 0,
    y: 2,
    name: "Whole",
    nameColor: "#00FF00",
    name2: "Tones",
    name2Color: "#FF7F00",
    formulae: [1, 3, 5, 7, 9, 11],
    formulaeOriginal: ["1", "3", "5", "7", "9", "A"],
    numbers: ["1", "2", "3", "♯4", "♯5", "♯6"],
    underlinedNumbers: ["2", "3", "♯5", "♯6"],
  },
];
const otherToneScales = [
  {
    x: 0,
    y: 0,
    name: "Blues scale",
    nameColor: "#fff",
    formulae: [1, 4, 6, 7, 8, 11],
    formulaeOriginal: ["1", "4", "6", "7", "8", "A"],
    numbers: ["1", "b3", "4", "♯4", "5", "b7"],
  },

  {
    x: 0,
    y: 1,
    name: "Chromatic scale",
    nameColor: "#fff",
    formulae: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    formulaeOriginal: [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "0",
      "A",
      "B",
    ],
    numbers: ["1", "b2", "2", "♯2", "3", "4", "♯4", "5", "♯5", "6", "♯6", "7"],
  },
];

export {
  getMidiNumber,
  VALIDNOTES,
  NOTES,
  ALLNOTES,
  otherToneScales,
  sevenToneScale,
  sixToneScale,
  eightToneScale,
  fiveToneScale,
  TONES,
  ALLNOTES2,
  ALLNOTES3,
  ALLNOTES4,
  ALLNOTES5,
  putLabelsOnPiano,
  changeLabels,
  generateStandardLabels,
};
